export default __webpack_public_path__ + "static/media/tr.9c674567.svg";